import {
  ButtonOptionsMessage as ButtonOptionsMessageType,
  Conversation,
} from '@stripe-internal/conversations-client';
import {view} from '@sail/ui';
import {ButtonOptionsMessage} from './ButtonOptionsMessage';
import {ChatRow} from '../../../Chat';

type Props = {
  conversation: Conversation;
  message: ButtonOptionsMessageType;
  animated?: boolean;
  disableInteraction?: boolean;
  ChatRowComponent?: React.ComponentType<React.ComponentProps<typeof ChatRow>>;
  ChatButtonOptionsComponent?: React.ComponentProps<
    typeof ButtonOptionsMessage
  >['ChatButtonOptionsComponent'];
};

export const ButtonOptionsMessageRow = ({
  conversation,
  message,
  animated,
  disableInteraction,
  ChatRowComponent = ChatRow,
  ChatButtonOptionsComponent,
}: Props) => {
  // if the user has manually entered text, we'll render that as
  // text message or text with attachments message instead of button options and we no longer
  // need to render the button options prompt
  if (
    message.selectedOptionId === 'text-input' ||
    message.selectedOptionId === 'text-with-attachments-input'
  ) {
    return null;
  }

  return (
    <view.div
      className="uh-conversations-button-options-message-row"
      data-testid="button-options-message-row"
      data-message-type="user"
    >
      <ChatRowComponent position="end">
        <ButtonOptionsMessage
          conversation={conversation}
          message={message}
          animated={animated}
          disableInteraction={disableInteraction}
          ChatButtonOptionsComponent={ChatButtonOptionsComponent}
        />
      </ChatRowComponent>
    </view.div>
  );
};
